export enum EduResourcesTab {
  Folder = "folder",
  Resources = "resources",
  AutoSend = "auto-send",
}
